import { IconsProps } from "@flash-tecnologia/hros-web-ui-v2";
import {
  PermissionProfiles,
  SetupWorkflowSteps,
  TrackingEvents,
  TrackingPages,
} from "../types";

export const REQUIRED_FORM_FIELD_ERROR = "Campo obrigatório";

export const PERMISSION_PROFILE_TITLE_MAP = {
  [PermissionProfiles.ADMINISTRATOR]: "Administrador de empresa",
  [PermissionProfiles.EMPLOYEE]: "Perfil de colaborador",
  [PermissionProfiles.SUPER_ADMINISTRATOR]: "Super Administrador",
};

export const SETUP_STEP_TITLE_MAP = {
  [SetupWorkflowSteps.ADD_COMPANIES]: "Cadastrar empresas",
  [SetupWorkflowSteps.ADD_MEMBERS]: "Cadastrar membros",
  [SetupWorkflowSteps.INVITE_MEMBERS]: "Convidar membros",
  [SetupWorkflowSteps.SUMMARY]: "Resumo",
};

export enum StepKeys {
  ADD_MEMBERS = "add-members",
  ADD_COMPANIES = "add-companies",
  KYC = "kyc",
}

export const WORKFLOW_TRACKING_EVENTS_MAP = {
  [SetupWorkflowSteps.ADD_MEMBERS]: {
    continue: TrackingEvents.SETUP_ADD_INDIVIDUAL_EMPLOYEE_CONTINUE_CLICKED,
    continueLater:
      TrackingEvents.SETUP_ADD_INDIVIDUAL_EMPLOYEE_CONTINUE_LATER_CLICKED,
    goBack: TrackingEvents.SETUP_ADD_INDIVIDUAL_EMPLOYEE_GO_BACK_CLICKED,
  },
  [SetupWorkflowSteps.INVITE_MEMBERS]: {
    continue: TrackingEvents.SETUP_SEND_INVITE_CONTINUE_CLICKED,
    continueLater: TrackingEvents.SETUP_SEND_INVITE_CONTINUE_LATER_CLICKED,
    goBack: TrackingEvents.SETUP_SEND_INVITE_GO_BACK_CLICKED,
  },
  [SetupWorkflowSteps.ADD_COMPANIES]: {
    continue: TrackingEvents.SETUP_ADD_COMPANIES_CONTINUE_CLICKED,
    continueLater: TrackingEvents.SETUP_ADD_COMPANIES_CONTINUE_LATER_CLICKED,
    goBack: TrackingEvents.SETUP_ADD_COMPANIES_GO_BACK_CLICKED,
  },
  [SetupWorkflowSteps.SUMMARY]: undefined,
};

export const WORKFLOW_TRACKING_PAGES_MAP = {
  workflow: {
    [SetupWorkflowSteps.ADD_MEMBERS]:
      TrackingPages.SETUP_ADD_INDIVIDUAL_EMPLOYEE_WORKFLOW_PAGE,
    [SetupWorkflowSteps.INVITE_MEMBERS]:
      TrackingPages.SETUP_SEND_INVITE_WORKFLOW_PAGE,
    [SetupWorkflowSteps.ADD_COMPANIES]:
      TrackingPages.SETUP_ADD_COMPANIES_WORKFLOW_PAGE,
    [SetupWorkflowSteps.SUMMARY]: TrackingPages.SETUP_SUMMARY_WORKFLOW_PAGE,
  },
};

export const STEPPER_STEP_ID_MAP = {
  [SetupWorkflowSteps.ADD_COMPANIES]: SetupWorkflowSteps.ADD_COMPANIES,
  [SetupWorkflowSteps.ADD_MEMBERS]: SetupWorkflowSteps.ADD_MEMBERS,
  [SetupWorkflowSteps.INVITE_MEMBERS]: SetupWorkflowSteps.ADD_MEMBERS,
  [SetupWorkflowSteps.SUMMARY]: undefined,
};

export const SETUP_WORKFLOW_STEPS_MAP = {
  [StepKeys.ADD_MEMBERS]: SetupWorkflowSteps.ADD_MEMBERS,
  [StepKeys.ADD_COMPANIES]: SetupWorkflowSteps.ADD_COMPANIES,
  [StepKeys.KYC]: undefined,
};

export const getModuleProps = (
  moduleId: string
): {
  name: string;
  icon: IconsProps["name"];
} => {
  switch (moduleId) {
    case "benefits":
      return { icon: "IconShoppingCart", name: "Benefícios" };
    case "expense":
    case "corporate_card":
      return { icon: "BriefCaseExpense", name: "Despesas" };
    case "performance":
      return { icon: "IconRocket", name: "Performance" };
    case "time_and_attendance":
      return { icon: "IconClock", name: "Controle de jornada" };
    case "hiring":
      return { icon: "IconUserSearch", name: "Recrutamento" };
    case "admission":
      return { icon: "IconLayoutKanban", name: "Admissão" };
    case "learning":
      return { icon: "IconSchool", name: "Treinamentos" };
    case "engagement":
      return { icon: "IconSpeakerphone", name: "Engajamento" };
    default:
      return { icon: "IconShoppingCart", name: "" };
  }
};
